import { render, staticRenderFns } from "./DuplicateDataRulesWidget.vue?vue&type=template&id=14303720&scoped=true"
import script from "./DuplicateDataRulesWidget.vue?vue&type=script&lang=js"
export * from "./DuplicateDataRulesWidget.vue?vue&type=script&lang=js"
import style0 from "./DuplicateDataRulesWidget.vue?vue&type=style&index=0&id=14303720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14303720",
  null
  
)

export default component.exports